import React, {useEffect} from 'react';
import SimpleRound from "../../styles/icons";
import FinderTopBar from "../../styles/finder/FinderTopBar";
import {barTitleAtom, barActionAtom, filterActive} from "../../atoms/atoms";
import {useAtom} from "jotai";
import {faChevronDown} from "@fortawesome/pro-light-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useResetAtom} from "jotai/utils";
import {AnimatePresence, motion} from "framer-motion";
import ReactGA from 'react-ga4';

type FinderBarComponent = () => JSX.Element;

const FinderBar: FinderBarComponent = () => {
  const resetBarTitle = useResetAtom(barTitleAtom);
  const resetBarAction = useResetAtom(barActionAtom);
  const [active,setActive] = useAtom(filterActive);
  const [barTitle] = useAtom(barTitleAtom);
  const [barAction] = useAtom(barActionAtom);

  useEffect(() => {
    if (!active) {
      resetBarAction();
      resetBarTitle();
    }
  }, [active])

  const Style = () => {
    if (barAction) {
      return <span style={{color: '#fff'}}>{barAction}</span>
    }
    return <></>
  }

  const barClickHandler = () => {
    ReactGA.event({
      category: 'ProductFinder',
      action: active ? "Close Finder" : "Open Finder",
    });
    setActive(!active);
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{height: 0}}
        animate={{height: 'auto'}}
        transition={{ease: 'anticipate', delay: 0.6, duration: 0.5}}
      >
        <FinderTopBar style={{ cursor: 'pointer' }} onClick={barClickHandler}>
          <div>
            <Style />
            <h2>{barTitle}</h2>
          </div>
          <SimpleRound>
          {active ? (
            <FontAwesomeIcon style={{width: 20}} icon={faChevronDown} />
          ) : (
            <span style={{ fontSize: '18px' }}>?</span>
          )}
          </SimpleRound>
        </FinderTopBar>
      </motion.div>
    </AnimatePresence>
  )
}

export default FinderBar
